module.exports = __webpack_public_path__ + "img/avatar4.7612890f.png";